var mentions_default = {
  "mentionPalette": "YniB7",
  "mention": "NkAOt",
  "mentionViewer": "Qs1kI",
  "mentionSuggestionsEntry": "Vdne-",
  "mentionSuggestionsEntryFocused": "OBSxf",
  "mentionSuggestionsEntryText": "-ltUe",
  "mentionSuggestionsEntryAvatar": "TrY4o",
  "mentionSuggestions": "orrye",
  "cursorDefault": "u77fi",
  "cursorPointer": "dFMO3"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
